// packages
import { h } from 'preact';

// components
import PureComponent from '../components/PureComponent';
import asyncComponent from '../components/AsyncComponent';

// county viewer needs to be an async component, because we want it to render after fetching data
const AsyncCountyViewer = asyncComponent(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "CountyViewer" */ '../components/CountyViewer'
  )
);

class TopCounties extends PureComponent {
  constructor() {
    super();

    this.state = {
      topCounties: [
        {
          name: 'Harris',
          fips: 48201,
        },
        {
          name: 'Dallas',
          fips: 48113,
        },
        {
          name: 'Tarrant',
          fips: 48439,
        },
        {
          name: 'Bexar',
          fips: 48029,
        },
        {
          name: 'Travis',
          fips: 48453,
        },
        {
          name: 'Collin',
          fips: 48085,
        },
        {
          name: 'Denton',
          fips: 48121,
        },
        {
          name: 'El Paso',
          fips: 48141,
        },
        {
          name: 'Fort Bend',
          fips: 48157,
        },
        {
          name: 'Hidalgo',
          fips: 48215,
        },
      ],
    };
  }

  render() {
    const { topCounties } = this.state;

    return (
      <div>
        {topCounties.map(county => {
          return (
            <AsyncCountyViewer
              key={county.fips}
              county={county.name}
              fips={county.fips}
              section="top-counties"
            />
          );
        })}
      </div>
    );
  }
}

export default TopCounties;
